// #35 KeyValue: his field names over their values, in a grid of `cols` columns (a <dl>), or as label-left rows
// (`rows`). An item may say where a carried, read-only value comes from (`lockFrom`, with the lock icon) and may span
// several columns.

import type { ReactNode } from "react";
import { cx } from "../lib/cx";
import { vars } from "../lib/vars";
import { Icon } from "./icons";

/** [label, value, lockFrom?, span?] */
export type KeyValueItem = readonly [label: ReactNode, value: ReactNode, lockFrom?: ReactNode, span?: number];

export interface KeyValueProps {
  items: readonly KeyValueItem[];
  /** Columns of the grid (default 3); ignored with `rows`. */
  cols?: number | undefined;
  /** Label left, value right, one row each, hairlines between. */
  rows?: boolean | undefined;
  /** Every value in the monospace face (ids, correlation ids). */
  mono?: boolean | undefined;
  className?: string | undefined;
}

export function KeyValue({ items, cols = 3, rows, mono, className }: KeyValueProps) {
  return (
    <dl className={cx("mc-kv", rows && "mc-kv-rows", mono && "mc-kv-mono", className)} style={rows ? undefined : vars({ "--mc-cols": cols })}>
      {items.map(([label, value, lockFrom, span], index) => (
        <div key={index} className="mc-kv-i" style={span && !rows ? vars({ "--mc-span": span }) : undefined}>
          <dt className="mc-kv-k">{label}</dt>
          <dd className={cx("mc-kv-v", lockFrom !== undefined && "mc-kv-src")}>
            {value}
            {lockFrom !== undefined ? <span className="mc-kv-from"><Icon name="lock" size={14} />{lockFrom}</span> : null}
          </dd>
        </div>
      ))}
    </dl>
  );
}
